<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card v-can:any="['view-site', 'edit-site', 'create-site']" title="CUSTOMER SITES" >
          <template slot="actions">
            <vs-button v-can="'create-site'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input v-can="'view-site'" icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table v-can="'view-site'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">NAME</vs-th>
                <vs-th sort-key="contact_1">TELEPHONE</vs-th>
                <vs-th sort-key="email">EMAIL</vs-th>
                <vs-th>WEB SITE</vs-th>
                <vs-th>ACTIVE STATUS</vs-th>
                <vs-th v-can="'edit-site'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>
                  <vs-td :data="data[indextr].telephone">
                    {{ data[indextr].country_code_telephone }} {{ data[indextr].telephone }}
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].website">
                    {{ data[indextr].website }}
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0;" :color="data[indextr].is_active ? 'primary' : 'danger'">
                      {{ data[indextr].is_active ? 'active' : 'de-active' }}
                    </vs-chip>
                  </vs-td>


                  <vs-td v-can="'edit-site'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-site'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-site-pop-up ref="createCustomerSitePopUp"/>
    <update-customer-site-pop-up ref="updateCustomerSitePopUp" />
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRepository = RepositoryFactory.get('supplier')
  import CreateCustomerSitePopUp from '@/components/popups/customer/CreateCustomerSitePopUp'
  import UpdateCustomerSitePopUp from '@/components/popups/customer/UpdateCustomerSitePopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSitePopUp,
      UpdateCustomerSitePopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {

    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        const {data} = await SupplierRepository.getCustomerSites(this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerSitePopUp.openPopup()
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerSitePopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
